import axios from "axios";
import { getUsers } from "./getUser";

/* FETCHING USER SIGN TYPE REQUEST */
const loginType = localStorage.getItem("loginType");

// const isProd = process.env.REACT_APP_IS_PROD === "true";
// const isLocal = process.env.REACT_APP_IS_LOCAL === "true";

// console.log(typeof isProd + " " + isProd);
// console.log(typeof isLocal + " " + isLocal);

/* AUTHENTICATION */
// const LOCAL_AUTH_URL = "http://localhost:4000";
// const AUTH_QA_URL = "https://auth-qa.rs-chain.com";
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
// const AUTH_PROD_URL = "https://auth.rs-chain.com";

/* ORDER */
// const ORDER_LOCAL_URL = "http://localhost:9000";
// const ORDER_QA_URL = "https://order-qa.rs-chain.com";
export const ORDER_BASE_URL = process.env.REACT_APP_ORD_BASE_URL;
// const ORDER_PROD_URL = "https://order.rs-chain.com";

/* ANALYTICS */
// const ANALYTICS_LOCAL_URL = "http://localhost:8000";
// const ANALYTICS_QA_URL = "https://payout-qa.rs-chain.com";
export const ANALYTICS_BASE_URL = process.env.REACT_APP_ANALYTICS_BASE_URL;
// const ANALYTICS_PROD_URL = "https://analytics.rs-chain.com";

/* SHIPMENT */
// const SHIPMENT_LOCAL_URL = "http://localhost:3500";
// const SHIPMENT_QA_URL = "https://shipment-qa.rs-chain.com";
export const SHIPMENT_BASE_URL = process.env.REACT_APP_SHIPMENT_BASE_URL;
// const SHIPMENT_PROD_URL = "https://shipment.rs-chain.com";

/* PAYMENTS */
// const PAYMENTS_LOCAL_URL = "http://localhost:7500";
// const PAYMENTS_QA_URL = "https://payout-qa.rs-chain.com";
export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENTS_BASE_URL;
// const PAYMENTS_PROD_URL = "https://payout.rs-chain.com";
// const getEnvironmentURL = (localURL, qaURL, prodURL) => {
//   if (isLocal) return localURL;
//   return isProd ? prodURL : qaURL;
// };

/* WAREHOUSE */
export const WAREHOUSE_BASE_URL = process.env.REACT_APP_WAREHOUSE_BASE_URL;

// export const AUTH_BASE_URL = getEnvironmentURL(
//   LOCAL_AUTH_URL,
//   AUTH_QA_URL,
//   AUTH_PROD_URL
// );
// export const ORDER_BASE_URL = getEnvironmentURL(
//   ORDER_LOCAL_URL,
//   ORDER_QA_URL,
//   ORDER_PROD_URL
// );
// export const ANALYTICS_BASE_URL = getEnvironmentURL(
//   ANALYTICS_LOCAL_URL,
//   ANALYTICS_QA_URL,
//   ANALYTICS_PROD_URL
// );
// export const SHIPMENT_BASE_URL = getEnvironmentURL(
//   SHIPMENT_LOCAL_URL,
//   SHIPMENT_QA_URL,
//   SHIPMENT_PROD_URL
// );
// export const PAYMENT_BASE_URL = getEnvironmentURL(
//   PAYMENTS_LOCAL_URL,
//   PAYMENTS_QA_URL,
//   PAYMENTS_PROD_URL
// );

const defaultHeader = () => {
  const access_token =
    loginType === "false"
      ? JSON.parse(sessionStorage.getItem("user"))?.access_token
      : JSON.parse(localStorage.getItem("user"))?.access_token;
  return {
    Authorization: `Bearer ${access_token}`,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
    "Access-Control-Allow-Headers":
      "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
    Accept: "application/json",
  };
};

export const authenticationApiRequest = async (
  method,
  endpoint,
  data = null,
  params,
  headers = {}
) => {
  try {
    const url = `${AUTH_BASE_URL}/${endpoint}`;
    console.log(url);
    const config = {
      method,
      url,
      params,
      data,
      headers: Object.keys(headers)?.length ? headers : defaultHeader(),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
};

export const analyticsApiRequest = async (
  method,
  endpoint,
  data = null,
  params,
  headers = {}
) => {
  try {
    const url = `${ANALYTICS_BASE_URL}/${endpoint}`;
    console.log(url);
    const config = {
      method,
      url,
      params,
      data,
      headers: Object.keys(headers)?.length ? headers : defaultHeader(),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
};

export const orderManagementApiRequest = async (
  method,
  endpoint,
  data = null,
  params,
  headers = {}
) => {
  try {
    const url = `${ORDER_BASE_URL}/${endpoint}`;
    console.log(url);
    const config = {
      method,
      url,
      params,
      data,
      headers: Object.keys(headers)?.length ? headers : defaultHeader(),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
};

export const shipmentApiRequest = async (
  method,
  endpoint,
  data = null,
  params,
  headers = {}
) => {
  try {
    const url = `${SHIPMENT_BASE_URL}/${endpoint}`;
    console.log(url);
    const config = {
      method,
      url,
      params,
      data,
      headers: Object.keys(headers)?.length ? headers : defaultHeader(),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
};

export const payoutsApiRequest = async (
  method,
  endpoint,
  data = null,
  params,
  headers = {}
) => {
  try {
    const url = `${PAYMENT_BASE_URL}/${endpoint}`;
    console.log(url);
    const config = {
      method,
      url,
      params,
      data,
      headers: Object.keys(headers)?.length ? headers : defaultHeader(),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // window.location.replace("/");
      console.log("error");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
};

export const warehouseApiRequest = async (
  method,
  endpoint,
  data = null,
  params,
  headers = {}
) => {
  try {
    const url = `${WAREHOUSE_BASE_URL}/${endpoint}`;
    console.log(url);
    const config = {
      method,
      url,
      params,
      data,
      headers: Object.keys(headers)?.length ? headers : defaultHeader(),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
};

export const createAxiosInstanceUser = (endpoint) => {
  const baseUrl = `${AUTH_BASE_URL}`;
  console.log(baseUrl);
  const instance = axios.create({
    baseURL: `${AUTH_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const user = getUsers();
        if (user) {
          const token = user?.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            console.warn("No access token found in user data.");
          }
        }
      } catch (error) {
        console.error("Error retrieving user data:", error.message);
      }
      return config;
    },
    (error) => {
      console.error(error);
    }
  );

  return instance;
};

export const createAxiosInstanceAanlysis = (endpoint) => {
  const instance = axios.create({
    baseURL: `${ANALYTICS_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const user = getUsers();
        if (user) {
          const token = user?.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            console.warn("No access token found in user data.");
          }
        }
      } catch (error) {
        console.error("Error retrieving user data:", error.message);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export const createAxiosInstanceOrder = (endpoint) => {
  const instance = axios.create({
    baseURL: `${ORDER_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const user = getUsers();
        if (user) {
          const token = user?.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            console.warn("No access token found in user data.");
          }
        }
      } catch (error) {
        console.error("Error retrieving user data:", error.message);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export const createAxiosShipment = (endpoint) => {
  const instance = axios.create({
    baseURL: `${SHIPMENT_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const user = getUsers();
        if (user) {
          const token = user?.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            console.warn("No access token found in user data.");
          }
        }
      } catch (error) {
        console.error("Error retrieving user data:", error.message);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export const createAxiosPayment = (endpoint) => {
  const instance = axios.create({
    baseURL: `${PAYMENT_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const user = getUsers();
        if (user) {
          const token = user?.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            console.warn("No access token found in user data.");
          }
        }
      } catch (error) {
        console.error("Error retrieving user data:", error.message);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export const createAxiosWarehouse = (endpoint) => {
  const instance = axios.create({
    baseURL: `${WAREHOUSE_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      try {
        const user = getUsers();
        if (user) {
          const token = user?.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            console.warn("No access token found in user data.");
          }
        }
      } catch (error) {
        console.error("Error retrieving user data:", error.message);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};